<ion-header [translucent]="true">
    <ion-toolbar *ngIf="mode === 'manage'">
        <ion-title>Memory cards</ion-title>

        <ion-buttons slot="primary">
            <ion-button (click)="addCardImage()">
                <ion-icon name="add-outline"></ion-icon>
            </ion-button>
        </ion-buttons>

        <ion-buttons slot="secondary">
            <ion-button (click)="openActionMenu($event)">
                <ion-icon name="ellipsis-vertical-outline"></ion-icon>
            </ion-button>

            <app-pwa-prompt></app-pwa-prompt>
        </ion-buttons>
    </ion-toolbar>

    <ion-toolbar *ngIf="mode !== 'manage'">
        <ion-title *ngIf="mode === 'select-for-export'">Export</ion-title>
        <ion-title *ngIf="mode === 'select-for-delete'">Delete</ion-title>

        <ion-buttons slot="primary">
            <ion-button (click)="onSelectionDone()">{{
                selection.size === 0 ? 'Cancel' : mode === 'select-for-export' ? 'Export' : 'Delete'
            }}</ion-button>
        </ion-buttons>

        <ion-buttons slot="secondary" *ngIf="selection.size !== cards.length">
            <ion-button (click)="onSelectAll()">Select all</ion-button>
        </ion-buttons>

        <ion-buttons slot="secondary" *ngIf="selection.size === cards.length">
            <ion-button (click)="selection.clear()">Clear</ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content (contextmenu)="onContextMenu($event)" [fullscreen]="true">
    <ion-header collapse="condense">
        <ion-toolbar>
            <ion-title size="large" *ngIf="mode === 'manage'">Memory cards</ion-title>
            <ion-title size="large" *ngIf="mode === 'select-for-export'">Select for export</ion-title>
            <ion-title size="large" *ngIf="mode === 'select-for-delete'">Select for delete</ion-title>
        </ion-toolbar>
    </ion-header>

    <div class="loader" *ngIf="storageCardService.isLoading()">
        <ion-spinner></ion-spinner>
    </div>

    <div *ngIf="!storageCardService.isLoading() && cards.length === 0" class="placeholder-container">
        <div class="placeholder">
            No memory cards. Select the &bdquo;+&ldquo; icon in the upper right corner in order to create a new card.
        </div>
    </div>

    <ion-list *ngIf="!storageCardService.isLoading() && cards.length > 0">
        <app-storage-card
            *ngFor="let card of cards; trackBy: trackCardBy"
            [card]="card"
            (delete)="deleteCard(card)"
            (selectCard)="mode === 'manage' ? browseCard(card) : toggleSelection(card)"
            (edit)="editCard(card)"
            (check)="checkCard(card)"
            (interaction)="lastCardTouched = card.id"
            (save)="saveCard(card)"
            [touched]="card.id === lastCardTouched"
            [selecting]="mode !== 'manage'"
            [selectedForExport]="selection.has(card.id)"
        >
        </app-storage-card>
    </ion-list>
</ion-content>
